module.exports = __webpack_public_path__ + "img/ctrl-hadamard-stub-up-+.7ed2d35b.svg";